import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { impersonationRoute } from '../../../admin/admin.routes';
import { ImpersonationService } from '../../../admin/impersonation/impersonation.service';
import { adminRoute } from '../../../app.routes';
import { EnhancedTranslatePipe } from '../../pipes/enhanced-translation.pipe';

@Component({
    selector: 'gt-impersonation-bar',
    templateUrl: './impersonation-bar.component.html',
    styleUrls: ['./impersonation-bar.component.scss'],
    imports: [EnhancedTranslatePipe, MatTooltip],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpersonationBarComponent {
    protected readonly impersonation = inject(ImpersonationService);
    private readonly router = inject(Router);

    protected endImpersonation(): void {
        this.impersonation.deactivate();
        this.router.navigate([`/${adminRoute}/${impersonationRoute}`]);
    }

    protected goToSettings(): void {
        this.router.navigate([`/${adminRoute}/${impersonationRoute}`]);
    }
}
